import React from "react"
import { graphql } from "gatsby"

import { getImage } from "gatsby-plugin-image"

import { Components } from "gatsby-theme-storyblok"
import { useNavigation } from "../hooks/use-navigation"
import { useSitemeta } from "../hooks/use-sitemeta"
import { useLogos } from "../hooks/use-logos"

import { Layout, Breadcrumb } from "gatsby-theme-gba"

const StoryblokPage = ({ data, pageContext, path, location }) => {
  const mainNavigation = useNavigation()
  const { siteMetadata } = useSitemeta()
  const {
    groupLogo,
    pharmaLogo,
    foodLogo,
    environmentLogo,
    cosmeticsLogo,
    veterinaryLogo,
    lifeScienceLogo,
    medicalLogo,
    agroChemicalLogo,
  } = useLogos()

  let logos = siteMetadata.logos
  logos.default.fixed = getImage(groupLogo)
  logos.pharma.fixed = getImage(pharmaLogo)
  logos.food.fixed = getImage(foodLogo)
  logos.environment.fixed = getImage(environmentLogo)
  logos.cosmetics.fixed = getImage(cosmeticsLogo)
  logos.veterinary.fixed = getImage(veterinaryLogo)
  logos.lifeScience.fixed = getImage(lifeScienceLogo)
  logos.agroChemical.fixed = getImage(agroChemicalLogo)
  logos.medical.fixed = getImage(medicalLogo)
  logos.sustainabilityServices.fixed = getImage(groupLogo)

  const prepareStory = (data, pageContext, path) => {
    let story = Object.assign({}, data.storyblokEntry)

    if (!story.uuid) {
      let customFallbackLang = "en"
      let fallbackStorys = data.fallbackStorys.nodes.sort(
        (firstEl, secondEl) => {
          if (firstEl.lang === secondEl.lang) {
            return 0
          }
          if (firstEl.lang === customFallbackLang) {
            return -1
          }
          return 0
        }
      )
      let fallbackStory = fallbackStorys[0] ? fallbackStorys[0] : {}

      fallbackStory.lang = pageContext.lang
      fallbackStory.full_slug = path
      story = Object.assign({}, fallbackStory)
    }

    if (!pageContext.uuid) {
      story = Object.assign({}, pageContext.story)
    }

    story.content = JSON.parse(story.content)
    let navigation = Object.assign({}, mainNavigation)

    navigation.content = JSON.parse(navigation.content)

    const navigationItems = navigation.content.navigationItems
    const newNavigationItems = {}
    for (let i = 0; i < navigationItems.length; i++) {
      newNavigationItems[navigationItems[i]["displayName"]] = navigationItems[i]
    }

    navigation.content.navigationItems = newNavigationItems

    let newNavigation = getParentData({ story }, getLanguage(story), navigation)

    navigation = newNavigation.navigation

    const allLang = Object.assign({}, pageContext.allLang)

    return { story, navigation, allLang }
  }

  const getLanguage = (story) => {
    let currentLanguage =
      story.lang === "default" || story.lang === "" ? "de" : story.lang
    return currentLanguage
  }

  const getParentData = (state, language, currentNavigation) => {
    let mode = "group"
    let childMode = ""
    let modeSet = false
    let footerSocialMedia = []
    let ChildFooterSocialMedia = []
    let contactDetails = []
    let pageContactDetails = []
    let defaultTitle =
      currentNavigation.content.navigationItems[language].children[0][
        "defaultTitle"
      ]
    let childPageTitle = ""
    let currentPageFullSlug =
      language === "de"
        ? state.story.full_slug
        : state.story.full_slug.substr(3)
    let currentPageUUID = state.story.uuid

    let checkIfChildPage = (subtree, currentPageUUID) => {
      let isChildPage = false
      for (let i = 0; i < subtree.length; i++) {
        if (subtree[i]["url"] && subtree[i]["url"]["id"] === currentPageUUID) {
          subtree[i]["open"] = true
          subtree[i]["currentPage"] = true
          isChildPage = true
          return { isChildPage, subtree }
        }
        if (subtree[i]["children"] && subtree[i]["children"].length > 0) {
          let repsone = checkIfChildPage(
            subtree[i]["children"],
            currentPageUUID
          )
          isChildPage = isChildPage || repsone["isChildPage"]
          if (repsone["isChildPage"]) {
            subtree[i]["open"] = true
          }
          subtree[i]["children"] = repsone["subtree"]
        }
        if (subtree[i]["extras"] && subtree[i]["extras"].length > 0) {
          let repsone = checkIfChildPage(subtree[i]["extras"], currentPageUUID)
          isChildPage = isChildPage || repsone["isChildPage"]
          if (repsone["isChildPage"]) {
            subtree[i]["open"] = true
          }
          subtree[i]["extras"] = repsone["subtree"]
        }
      }
      return { isChildPage, subtree }
    }

    let navigation =
      currentNavigation.content.navigationItems[language].children

    for (let i = 0; i < navigation.length; i++) {
      if (!Object.values(contactDetails).some((v) => v)) {
        contactDetails = {
          phone: navigation[i]["contactPhone"],
          email: navigation[i]["contactEmail"],
          contact: navigation[i]["contact"],
        }
      }

      if (currentPageFullSlug.startsWith("/")) {
        currentPageFullSlug = currentPageFullSlug.substring(1)
      }
      if (currentPageFullSlug.includes(navigation[i]["mode"])) {
        mode = navigation[i]["mode"]
        footerSocialMedia = navigation[i]["footerItems"]
        defaultTitle = navigation[i]["defaultTitle"]
        contactDetails = {
          phone: navigation[i]["contactPhone"],
          email: navigation[i]["contactEmail"],
          contact: navigation[i]["contact"],
        }
      } else if (
        currentPageFullSlug.startsWith("gebaeudeschadstoffe-bausubstanz/")
      ) {
        mode = "construction"
      } else if (
        currentPageFullSlug.startsWith("building-contaminants-and-materials/")
      ) {
        mode = "construction"
      } else if (currentPageFullSlug.startsWith("veterinaer/")) {
        mode = "veterinary"
      } else if (currentPageFullSlug.startsWith("life-sciences/")) {
        mode = "lifeScience"
      } else if (currentPageFullSlug.startsWith("agro-chemicals/")) {
        mode = "agroChemical"
      } else if (currentPageFullSlug.startsWith("water/")) {
        mode = "wasser"
      }

      if (navigation[i]["children"]) {
        navigation[i]["children"].forEach((ele) => {
          if (
            currentPageFullSlug.includes(ele["mode"]) ||
            mode === ele["mode"]
          ) {
            childMode = ele["mode"] ? ele["mode"] : mode
            ChildFooterSocialMedia = ele["footerItems"]
            childPageTitle = ele["defaultTitle"]

            contactDetails = {
              phone: ele["contactPhone"],
              email: ele["contactEmail"],
              contact: ele["contact"],
            }
          }
        })
      }
    }

    for (let i = 0; i < navigation.length; i++) {
      if (navigation[i]["children"] && navigation[i]["children"].length > 0) {
        let response = checkIfChildPage(
          navigation[i]["children"],
          currentPageUUID
        )

        if (response["isChildPage"]) {
          for (let j = 0; j < response["subtree"].length; j++) {
            if (
              response["subtree"][j]["children"] &&
              response["subtree"][j]["children"].length > 0 &&
              !response["subtree"][j]["currentPage"]
            ) {
              let subtreeResponse = checkIfChildPage(
                response["subtree"][j]["children"],
                currentPageUUID
              )

              if (subtreeResponse["isChildPage"]) {
                for (let k = 0; k < subtreeResponse["subtree"].length; k++) {
                  if (
                    subtreeResponse["subtree"][k]["currentPage"] &&
                    (subtreeResponse["subtree"][k]["contactEmail"] ||
                      subtreeResponse["subtree"][k]["hideIcon"])
                  ) {
                    pageContactDetails = {
                      phone: subtreeResponse["subtree"][k]["contactPhone"],
                      email: subtreeResponse["subtree"][k]["contactEmail"],
                      hideIcon: subtreeResponse["subtree"][k]["hideIcon"],
                    }
                  }
                }
              }
            } else {
              if (
                response["subtree"][j]["currentPage"] &&
                (response["subtree"][j]["contactEmail"] ||
                  response["subtree"][j]["hideIcon"])
              ) {
                pageContactDetails = {
                  phone: response["subtree"][j]["contactPhone"],
                  email: response["subtree"][j]["contactEmail"],
                  hideIcon: response["subtree"][j]["hideIcon"],
                }
              }
            }
          }
        }
      }
      if (!Object.values(pageContactDetails).some((v) => v)) {
        pageContactDetails = false
      }
    }

    for (let i = 0; i < navigation.length; i++) {
      if (
        navigation[i]["url"] &&
        navigation[i]["url"]["id"] === currentPageUUID
      ) {
        navigation[i]["currentPage"] = true
        mode = !modeSet ? (childMode ? childMode : navigation[i]["mode"]) : mode
        footerSocialMedia = !modeSet
          ? navigation[i]["footerItems"]
          : footerSocialMedia
        defaultTitle = !modeSet ? navigation[i]["defaultTitle"] : defaultTitle
        modeSet = true
      }

      let isChildPage = false
      if (navigation[i]["children"] && navigation[i]["children"].length > 0) {
        let repsone = checkIfChildPage(
          navigation[i]["children"],
          currentPageUUID
        )
        isChildPage = isChildPage || repsone["isChildPage"]
        navigation[i]["children"] = repsone["subtree"]
      }
      if (navigation[i]["extras"] && navigation[i]["extras"].length > 0) {
        let repsone = checkIfChildPage(navigation[i]["extras"], currentPageUUID)
        isChildPage = isChildPage || repsone["isChildPage"]
        navigation[i]["extras"] = repsone["subtree"]
      }
      if (isChildPage) {
        mode = !modeSet ? (childMode ? childMode : navigation[i]["mode"]) : mode
        footerSocialMedia = !modeSet
          ? navigation[i]["footerItems"]
          : footerSocialMedia

        defaultTitle = !modeSet ? navigation[i]["defaultTitle"] : defaultTitle
        modeSet = true

        navigation[i]["children"].forEach((ele) => {
          if (ele["url"] && ele["url"]["id"] === currentPageUUID) {
            ele["currentPage"] = true
            mode = !modeSet ? (childMode ? childMode : ele["mode"]) : mode
            if (ele["mode"] === "sustainabilityServices") {
              mode = ele["mode"]
            }
            footerSocialMedia = !modeSet
              ? ele["footerItems"]
              : footerSocialMedia
            defaultTitle = !modeSet ? ele["defaultTitle"] : defaultTitle
            modeSet = true
          }
          if (logos[mode] && ele["currentPage"]) {
            logos[mode].home = ele["url"]
          }

          let isChildPage = false
          if (ele["children"] && ele["children"].length > 0) {
            let repsone = checkIfChildPage(ele["children"], currentPageUUID)
            isChildPage = isChildPage || repsone["isChildPage"]
            ele["children"] = repsone["subtree"]
          }
          if (ele["extras"] && ele["extras"].length > 0) {
            let repsone = checkIfChildPage(ele["extras"], currentPageUUID)
            isChildPage = isChildPage || repsone["isChildPage"]
            ele["extras"] = repsone["subtree"]
          }
          if (isChildPage) {
            mode = !modeSet ? (childMode ? childMode : ele["mode"]) : mode
            footerSocialMedia = !modeSet
              ? ele["footerItems"]
              : footerSocialMedia
            defaultTitle = ele["defaultTitle"]
            modeSet = true

            if (logos[mode]) {
              logos[mode].home = ele["url"]
            }
          }
        })
      }
    }

    if (currentPageFullSlug.startsWith("blog/")) {
      defaultTitle = "GBA Group"
      childPageTitle = "GBA Group"
    }

    let newNavigation = currentNavigation
    newNavigation.content.navigationItems[language].children = navigation

    footerSocialMedia = ChildFooterSocialMedia.length
      ? ChildFooterSocialMedia
      : footerSocialMedia.length
        ? footerSocialMedia
        : navigation[0].footerItems

    newNavigation.content.navigationItems[language].footerSocialMedia =
      footerSocialMedia

    contactDetails = pageContactDetails || contactDetails
    defaultTitle = childPageTitle || defaultTitle
    return {
      mode,
      contactDetails,
      defaultTitle,
      navigation: newNavigation,
    }
  }

  const preparedStory = prepareStory(data, pageContext, path)
  const content = preparedStory.story.content
  const language = getLanguage(preparedStory.story)

  let languages = preparedStory.allLang

  const getMode = (state, language) => {
    const { mode } = getParentData(state, language, preparedStory.navigation)
    return mode
  }
  const getContactDetails = (state, language) => {
    const { contactDetails } = getParentData(
      state,
      language,
      preparedStory.navigation
    )
    return contactDetails
  }

  const getDefaultTitle = (state, language) => {
    const { defaultTitle } = getParentData(state, language, state.navigation)
    return defaultTitle
  }

  const currentMode = getMode(preparedStory, language)
  const contactDetails = getContactDetails(preparedStory, language)

  return (
    <Layout
      favicon={siteMetadata.favicon}
      appleFavicon={siteMetadata.appleFavicon}
      logos={logos}
      currentMode={currentMode}
      navigation={preparedStory.navigation.content.navigationItems}
      allLanguage={languages}
      currentLanguage={language}
      currentURL={preparedStory.story.uuid || preparedStory.story.slug}
      title={content?.title || content?.defaultTitle}
      defaultTitle={getDefaultTitle(preparedStory, language)}
      contactDetails={contactDetails}
      canonicalLink={
        pageContext.canonicalLink ? pageContext.canonicalLink : null
      }
      imageURL={content?.imageURL}
      description={content?.description}
      location={location}
      enableCookieBot={true}
    >
      {React.createElement(Components(content.component), {
        key: content._uid,
        breadcrumb: (
          <Breadcrumb
            language={language}
            mode={currentMode}
            location={location}
            languages={Object.values(languages)}
          />
        ),
        blok: {
          ...content,
          ...pageContext, // brauchen wir hier den kompletten Page Context?
          sort_by_date: preparedStory.story.sort_by_date,
          currentLanguage: language,
          location,
        },
      })}
    </Layout>
  )
}

export default StoryblokPage

export const pageTemplateQuery = graphql`
  query ($uuid: String, $lang: String) {
    storyblokEntry(uuid: { eq: $uuid }, lang: { eq: $lang }) {
      id
      name
      created_at
      uuid
      slug
      full_slug
      content
      lang
      is_startpage
      parent_id
      group_id
      sort_by_date
    }
    fallbackStorys: allStoryblokEntry(filter: { uuid: { eq: $uuid } }) {
      nodes {
        id
        name
        created_at
        uuid
        slug
        full_slug
        content
        lang
        is_startpage
        parent_id
        group_id
        sort_by_date
      }
    }
  }
`
